import React, { Fragment,useEffect,useState } from "react";
import { Col, Form, Row } from "reactstrap";
import TextInput from "../../../components/InputFields/TextInput";
import { useFormik } from "formik";
import { formikAddUser, genderOptions } from "../Constant";
import { failed, success } from "../../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Loader from "../../../components/Loader/Loader";
import "./Users.css";
import { useGetStates } from "../../../hooks/useGetStates";
import { createSuperAdminUser } from "../../../api/User";
import MultiSelect from "../../../components/InputFields/MultiSelect";
import DatePickerSelector from "../../../components/InputFields/DatePicker";
import moment from "moment";
import { decryptData } from "../../../utils/helper";
import { getRoles } from '../../../api/User';
import { getOrg } from "../../../api/orgnizations";
import { platformLayout } from "../../../utils/constants";

const CreateUser = ({setCurrentTab}) => {
    let token = useSelector(state => state.userReducer.token);
    let role = localStorage.getItem("userRole");
    let user = useSelector(state => state.userReducer.user);
    const orgList = useSelector(state => state.userReducer.user.organizations);
    const defaultOrg = orgList.find((org)=> org?.organizationId?._id === user?.defaultLogInOrg);
    const [isLoading, setIsLoading] = useState(false);
    const [RolesOption, setRolesOption] = useState([]);
    const [orgData, setOrgData] = useState([]);
    const [Clinic, setClinic] = useState([]);
    const [selectedRole, setSelectedRole] = useState([]);
    const dispatch = useDispatch();
    const [Countryvalue, setCountryValue] = useState();
    const [stateValue, setStateValue] = useState();
    const { states, countryOptions } = useGetStates(Countryvalue);

    const formik = useFormik({
        ...formikAddUser,
        validationSchema: Yup.object({
          firstName: Yup.string().required("Required Field"),
          lastName: Yup.string().required("Required Field"),
          roles: Yup.array().required("Required Field").min(1, "Required Field"),
          email: Yup.string().email("Invalid Email Format").required("Required Field"),
          primaryPhone: Yup.string().required("Required Field"),
          jobTitle: Yup.string().required("Required Field"),
          gender: Yup.string().required("Required Field"),
          // secondaryPhone: Yup.string().required("Required Field"),
          // address: Yup.string().required("Required Field"),
          city: Yup.string().required("Required Field"),
          state: Yup.string().required("Required Field"),
          postalCode: Yup.string().required("Required Field"),
          country: Yup.string().required("Required Field"),
          employer: Yup.string().required("Required Field"),
          department: Yup.string().required("Required Field"),
          // dob: Yup.string().required("Required Field"),
          defaultLogInOrg: role === platformLayout.Platform ? selectedRole?.map((role)=> role.portalLayout).includes(platformLayout.Organization) ?  Yup.string().required("Required Field") : Yup.string().notRequired() : Yup.string().required("Required Field"),
          defaultLogInClinic: role === platformLayout.Platform ? selectedRole?.map((role)=> role.portalLayout).includes(platformLayout.Organization) ?  Yup.string().required("Required Field") : Yup.string().notRequired() : Yup.string().required("Required Field"),
          defaultRoleId: Yup.string().required("Required Field"),
          orgId: role === platformLayout.Platform ? selectedRole?.map((role)=> role.portalLayout).includes(platformLayout.Organization) ?  Yup.string().required("Required Field") : Yup.string().notRequired() : Yup.string().required("Required Field")
        }),
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await createSuperAdminUser({ values, dispatch, token });
                if (res?.status == "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    formik.resetForm();
                    setCurrentTab("userListing");
                }else{
                  setIsLoading(false);
                  failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const CountrychangeHandler = e => {
        setCountryValue(e.target.value);
        formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
    };
    const stateHandler = (e) => {
        setStateValue(e.target.value);
        formik.setFieldValue('state', e.target.value);
    };

    const getRolesList =async(page, limit, searchKey = "")=>{
      let res;
      try {
          setIsLoading(true);
          res = await getRoles({ dispatch, token, page, limit, searchKey });
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            if(role === platformLayout.Platform){
              setRolesOption(responseData?.items?.filter((item)=> item?.active !== false).map((obj)=> {
                return {
                  label: obj.roleName,
                  value: obj?._id,
                  portalLayout : obj?.portalLayout
                };
              }));
            }else{
              setRolesOption(responseData.items?.filter(item=> item.portalLayout === platformLayout.Organization)?.map((obj)=> {
                return {
                  label: obj.roleName,
                  value: obj?._id,
                  portalLayout : obj?.portalLayout
                };
              }));
            }
            setIsLoading(false);
          }else{
            setIsLoading(false);
          }
      } catch (error) {
          failed(res?.message);
          setIsLoading(false);
      }
    };

      const getOrgList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            res = await getOrg({ dispatch, token, page, limit , searchKey, dataLimit: "all" });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                setOrgData(responseData.items);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };


    const handleOrgSearch=(e, newInputValue, reason)=>{
        if(reason == "input"){
            getOrgList(orgData?.currentPage, 10, e.target.value);
        }
    };

    const handleSelect = (orgId)=>{
        setClinic(orgData?.find((obj)=> obj._id == orgId).clinics?.map((val)=> {
            return {label: val.name, value: val._id};
        }));
        formik.setFieldValue("defaultLogInOrg", orgId);
    };

    const handleHospital = (e)=>{
      formik.setFieldValue("defaultLogInClinic", e.target.value);
      formik.setFieldValue('hospitalAccess', [...formik.values.hospitalAccess, e.target.value]);
    };

    const handleRoles = (roles) => {
      formik.setFieldValue("roles", roles);
      setSelectedRole(roles);

      // Update defaultRoleId if necessary
      if (!roles.find((role) => role.value === formik.values.defaultRoleId)) {
        const newDefaultRoleId = roles[0]?.value || ""; // Set first role or empty if no roles left
        formik.setFieldValue("defaultRoleId", newDefaultRoleId);
        formik.setFieldValue(
          "defaultRole",
          roles.find((role) => role.value === newDefaultRoleId) || null
        );
      }
    };

    // Handles default role selection
    const handleDefaultRole = (e) => {
      const selectedValue = e.target.value;
      formik.setFieldValue("defaultRoleId", selectedValue);
      formik.setFieldValue(
        "defaultRole",
        formik.values.roles?.find((role) => role.value === selectedValue) || null
      );
    };

    useEffect(() => {
      if(role === platformLayout.Organization){
        formik.setFieldValue("orgId", user?.defaultLogInOrg);
        formik.setFieldValue("defaultLogInOrg", user?.defaultLogInOrg);
      }
    }, []);

    useEffect(() => {
      window.scrollTo(0, 0); // Add this line
      getOrgList(orgData?.currentPage, 10);
    }, []);
    useEffect(() => {
      window.scrollTo(0, 0); // Add this line
      getRolesList();
    }, []);

  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      <div className="organization_form_block organization_blk p-0 m-0">
        <div className="">
          <div className="forms_block">
            <h6 className="title_blk mb-2 mt-0 text-center">Create User</h6>
            <Form  onSubmit={formik.handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {

                e.preventDefault();
              }
          }}
       >
              <div className="first_block modal_change_color">
                <Row>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"firstName"}
                      formik={formik}
                      label="First Name"
                      type="text"
                      placeholder="First Name"
                      value={formik.values.firstName}
                      onChange={(e) => formik.setFieldValue("firstName", e.target.value)}
                    />
                  </Col>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"lastName"}
                      formik={formik}
                      label="Last Name"
                      placeholder={"Last Name"}
                      type="text"
                      value={formik.values.lastName}
                      onChange={(e) => formik.setFieldValue("lastName", e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"gender"}
                      formik={formik}
                      label="Gender"
                      type="select"
                      options={genderOptions}
                      placeholder="gender"
                      value={formik.values.gender}
                      onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                    />
                  </Col>
                  <Col lg={6} className="location_block modal_pro_file ">
                  <DatePickerSelector
                    keyField={"dob"}
                    formik={formik}
                    value={formik.values?.dob}
                    minDate={""}
                    maxDate={moment()}
                    label="Date Of Birth"
                    type="date"
                    onChange={(e) => formik.setFieldValue("dob", moment(e).format("MM-DD-YYYY"))}
                  />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} className="location_block">
                    <MultiSelect
                      keyField={"roles"}
                      formik={formik}
                      label="User Roles"
                      options={RolesOption}
                      type="select"
                      placeholder="User Roles"
                      value={formik.values.roles}
                      onChange={handleRoles}
                    />
                  </Col>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"defaultRoleId"}
                      formik={formik}
                      label="Default Role"
                      type="select"
                      options={formik.values.roles}
                      value={formik.values.defaultRoleId}
                      onChange={handleDefaultRole}
                    />
                  </Col>
                </Row>
              </div>
              <div className="first_block modal_change_color">
                 <h6 className="block_name mt-0 mb-3 mt-0 mb-3 mt-0 mb-3">Contact Information</h6>
                <Row>
                  <Col lg={12} className="location_block">
                    <TextInput
                      keyField={"email"}
                      formik={formik}
                      label="Email"
                      type="email"
                      placeholder="Email"
                      value={formik.values.email}
                      onChange={(e) => formik.setFieldValue("email", e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"primaryPhone"}
                      formik={formik}
                      label="Mobile Phone Number"
                      type="phone"
                      placeholder="Mobile Phone Number"
                      value={formik.values.primaryPhone}
                      onChange={(e) => formik.setFieldValue("primaryPhone", e)}
                    />
                  </Col>
                  <Col lg={6} className="location_block">
                    <TextInput
                      keyField={"secondaryPhone"}
                      formik={formik}
                      label="Secondary Phone Number"
                      type="phone"
                      required={false}
                      placeholder="Secondary Phone Number"
                      value={formik.values.secondaryPhone}
                      onChange={(e) => formik.setFieldValue("secondaryPhone", e)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="first_block second_block modal_change_color">
                    <h6 className="block_name mt-0 mb-3 mt-0 mb-3 mt-0 mb-3"> Address Information</h6>
                    <Row>
                        <Col lg={12} className="location_block">
                            <TextInput
                                keyField={"address"}
                                formik={formik}
                                label="Street"
                                type="text"
                                placeholder="Street"
                                value={formik.values.address}
                                required={false}
                                onChange={(e) => formik.setFieldValue("address", e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className="location_block">
                            <TextInput
                                keyField={"country"}
                                formik={formik}
                                options={countryOptions}
                                label="Country"
                                type="select"
                                // placeholder="Country"
                                value={Countryvalue}
                                onChange={CountrychangeHandler}
                            />
                        </Col>
                        <Col lg={6} className="location_block">
                            <TextInput
                                keyField={"state"}
                                formik={formik}
                                label="State"
                                options={states.map((obj) => {
                                    return {
                                        label: obj.name,
                                        value: obj.name
                                    };
                                })}
                                type="select"
                                placeholder="State"
                                value={stateValue}
                                onChange={stateHandler}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className="location_block">
                            <TextInput
                                keyField={"city"}
                                formik={formik}
                                label="City"
                                type="text"
                                placeholder="City"
                                value={formik.values.city}
                                onChange={(e) => formik.setFieldValue("city", e.target.value)}
                            />
                        </Col>
                        <Col lg={6} className="location_block">
                            <TextInput
                                keyField={"postalCode"}
                                formik={formik}
                                label="Zip Code"
                                type="text"
                                placeholder="Zip Code"
                                value={formik.values.postalCode}
                                onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                            />
                        </Col>
                    </Row>
              </div>
              <div className="first_block second_block modal_change_color">
                    <h6 className="block_name mt-0 mb-3 mt-0 mb-3 mt-0 mb-3"> Employer Information</h6>
                    <Row>
                      <Col lg={6} className="location_block">
                        <TextInput
                            keyField={"employer"}
                            formik={formik}
                            label="Employer Name"
                            type="text"
                            placeholder="Employer Name"
                            value={formik.values.employer}
                            onChange={(e) => formik.setFieldValue("employer", e.target.value)}
                        />
                      </Col>
                      <Col lg={6} className="location_block">
                        <TextInput
                            keyField={"department"}
                            formik={formik}
                            label="Department Name"
                            type="text"
                            placeholder="Department Name"
                            value={formik.values.department}
                            onChange={(e) => formik.setFieldValue("department", e.target.value)}
                        />
                      </Col>

                    </Row>
                    <Row>
                      <Col lg={6} className="location_block">
                        <TextInput
                          keyField={"jobTitle"}
                          formik={formik}
                          label="Job Title"
                          type="text"
                          placeholder="Job Title"
                          value={formik.values.jobTitle}
                          onChange={(e) => formik.setFieldValue("jobTitle", e.target.value)}
                        />
                       </Col>
                    </Row>
              </div>
             {role === platformLayout.Platform ?
             (formik.values.roles.some((role) => role.portalLayout === platformLayout.Organization) &&
              <div className="first_block second_block modal_change_color">
                    <h6 className="block_name mt-0 mb-3 mt-0 mb-3"> Organization Information</h6>
                    <Row>
                      <Col lg={6} className="location_block">
                        <MultiSelect
                            keyField={"orgId"}
                            multiple={false}
                            formik={formik}
                            label="Select Organization"
                            options={orgData
                              ?.map((obj) => {
                                  return {
                                      label: obj?.name,
                                      value: obj._id
                                  };
                              })}
                            type="select"
                            placeholder="Select Organization"
                            disabled={!orgData?.length > 0}
                            required={formik.values.roles.map((role)=> role.portalLayout).includes(platformLayout.Organization)}
                            value={formik?.values?.orgId}
                            handleInput={(e, newInputValue, reason)=> handleOrgSearch(e, newInputValue, reason)}
                            onChange={handleSelect}
                        />
                       </Col>
                      <Col lg={6} className="location_block">
                        <TextInput
                            keyField={"defaultLogInClinic"}
                            formik={formik}
                            label="Hospital"
                            type="select"
                            required={formik.values.roles.map((role)=> role.portalLayout).includes(platformLayout.Organization)}
                            options={Clinic}
                            value={formik.values.defaultLogInClinic}
                            onChange={handleHospital}
                        />
                      </Col>
                    </Row>
              </div> )
              : <div className="first_block second_block modal_change_color">
                    <h6 className="block_name mt-0 mb-3 mt-0 mb-3"> Organization Information</h6>
                    <Row>
                      <Col lg={6} className="location_block">
                        <MultiSelect
                            keyField={"orgId"}
                            multiple={false}
                            formik={formik}
                            label="Select Organization"
                            options={orgData
                              ?.map((obj) => {
                                  return {
                                      label: obj?.name,
                                      value: obj._id
                                  };
                              })}
                            type="select"
                            placeholder="Select Organization"
                            disabled={true}
                            required={true}
                            value={user?.defaultLogInOrg}
                            handleInput={(e, newInputValue, reason)=> handleOrgSearch(e, newInputValue, reason)}
                            onChange={handleSelect}
                        />
                       </Col>
                      <Col lg={6} className="location_block">
                        <TextInput
                            keyField={"defaultLogInClinic"}
                            formik={formik}
                            label="Hospital"
                            type="select"
                            required={true}
                            options={defaultOrg?.clinicId.length > 0 && defaultOrg?.clinicId.map((clinic)=> {
                              return {
                                label : clinic?.name,
                                value : clinic?._id
                              };
                            })}
                            value={formik.values.defaultLogInClinic}
                            onChange={handleHospital}
                        />
                      </Col>
                    </Row>
              </div>}
              <div className="d-flex justify-content-between">
                <button className="save_btn" onClick={() => setCurrentTab("userListing")}>Cancel</button>
                <div className="d-flex gap-3">
                  <button className="save_btn" type="submit">Save</button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CreateUser;
